// Simple access control utility
export const checkSessionAccess = (sessionName, permission = 'read') => {
  try {
    const authorizedSessions = sessionStorage.getItem('AuthorizedSessions');
    
    if (!authorizedSessions || authorizedSessions === '') {
      return false;
    }

    const sessions = JSON.parse(authorizedSessions);
    
    // Check if user has access to the required session
    for (const parentMenu in sessions) {
      if (sessions[parentMenu] && Array.isArray(sessions[parentMenu])) {
        const hasAccess = sessions[parentMenu].some(session => 
          session.subMenu === sessionName && 
          session[permission] === true
        );
        
        if (hasAccess) {
          return true;
        }
      }
    }
    
    return false;
  } catch (error) {
    console.error('Error checking session access:', error);
    return false;
  }
};

export const hasReadAccess = (sessionName) => {
  return checkSessionAccess(sessionName, 'read');
};

export const hasWriteAccess = (sessionName) => {
  return checkSessionAccess(sessionName, 'write');
};